import {Directive, ElementRef, Input} from '@angular/core';

@Directive({
   selector: '[background-image]'
})
export class BackgroundImageDirective {
   private el: HTMLElement;

   constructor(el: ElementRef) {
       this.el = el.nativeElement;
   }

   @Input('background-image') backgroundImage: string;

   ngAfterViewInit() {
       this.el.style.backgroundImage = 'url(' + this.backgroundImage + ')';
       this.el.style.backgroundRepeat = 'no-repeat';
       this.el.style.backgroundSize = 'cover';
   }

}



// WEBPACK FOOTER //
// ./src/directives/background-image/background-image.ts